import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserConfigState } from '@store/reducers/user-config.reducer';

export const selectUserConfigState =
  createFeatureSelector<UserConfigState>('userConfig');

export const selectUserConfig = createSelector(
  selectUserConfigState,
  (state: UserConfigState) => state.userConfig
);

export const selectLeftSideContainerWidth = createSelector(
  selectUserConfig,
  (userConfig) => userConfig.leftSideContainerWidth
);

export const selectRightSideContainerWidth = createSelector(
  selectUserConfig,
  (userConfig) => userConfig.rightSideContainerWidth
);

export const selectFramesHeight = createSelector(
  selectUserConfig,
  (userConfig) => userConfig.framesHeight ?? 200
);

export const selectCanvasHintsExpanded = createSelector(
  selectUserConfig,
  (userConfig) => userConfig.canvasHintsExpanded === true
);